// Volgnummer (1-based) van een contactmoment binnen ALLE momenten van de rapportage.
//
// Ticket #268311: buildTranscriptie nummerde met de positie in de LIJST DIE WERD DOORGEGEVEN. Bij het
// rapporteren van één los contactmoment (lijst met 1 item) werd het tweede moment daardoor als
// "CONTACTMOMENT 1" naar de AI gestuurd en als "eerste contactmoment" uitgeschreven.
export function getContactmomentNummer(moment, alleMomenten, fallbackIndex = 0) {
  const lijst = alleMomenten || [];
  let positie = lijst.indexOf(moment);
  if (positie < 0 && moment && moment.id !== undefined && moment.id !== null) {
    positie = lijst.findIndex((m) => m && m.id === moment.id);
  }
  return (positie >= 0 ? positie : fallbackIndex) + 1;
}
